// stores/useSchedulingModal.ts
import { create } from "zustand"

interface SchedulingModalState {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

export const useSettingsModal = create<SchedulingModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
}))
